import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/AllAdvertisers.graphql';
import { Query, QueryallAdvertisersArgs } from '../../__generated__/globalTypes';

export const useAllAdvertisersQuery = (options?: QueryHookOptions<Query, QueryallAdvertisersArgs>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryallAdvertisersArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useAllAdvertisersLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryallAdvertisersArgs>
): QueryResult<Query, QueryallAdvertisersArgs> & {
  getAllAdvertisers: LazyQueryExecFunction<Query, QueryallAdvertisersArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getAllAdvertisers, result] = useLazyQuery<Query, QueryallAdvertisersArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getAllAdvertisers, ...result };
};

export const useAllAdvertisersPromiseQuery = () => {
  const client = useApolloClient();

  const getAllAdvertisers = useCallback(
    (options?: Omit<QueryOptions<QueryallAdvertisersArgs, Query>, 'query'>) =>
      client.query<Query, QueryallAdvertisersArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getAllAdvertisers };
};
// Suspense Query Hooks
export const useAllAdvertisersSuspenseQuery = (options?: SuspenseQueryHookOptions<Query, QueryallAdvertisersArgs>) => {
  const result = useSuspenseQuery<Query, QueryallAdvertisersArgs>(QUERY, {
    ...options
  });

  return result;
};
